/**
 * Build identity, stamped by `define` in vite.config.ts.
 *
 * A PWA caches aggressively and a stale service worker looks identical to a
 * fresh one, so "which build am I actually running?" has to be answerable from
 * inside the app itself — not from the deploy log.
 */
export const APP_VERSION: string = __APP_VERSION__
export const BUILD_COMMIT: string = __BUILD_COMMIT__
export const BUILD_TIME: string = __BUILD_TIME__

/**
 * True when this came off the dev server rather than a real build. The dev
 * server deliberately ships no commit or timestamp: those are frozen at config
 * load, so on a server left running they drift out of date while the code
 * around them stays current. Better to show nothing than something wrong.
 */
export const IS_DEV_BUILD: boolean = BUILD_COMMIT === 'dev'

/** Build time in the viewer's own timezone — UTC means nothing on a phone. */
export function formatBuildTime(iso: string = BUILD_TIME): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return 'unknown'
  return d.toLocaleString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** e.g. `17 Aug 2026, 14:32 · 7e9926b`, or `dev server` when not a real build. */
export function buildLabel(): string {
  if (IS_DEV_BUILD) return 'dev server'
  return `${formatBuildTime()} · ${BUILD_COMMIT}`
}
